// R15b-b3: converted native in place (antd Spin → kit Spinner). STATIC-imported
// by the realTime provider (APL-11850, v3 parity — boot fallback must not be a
// lazy chunk).
import { Spinner } from '@/components/ui/spinner';

export const CustomSpinner = () => {
  return <Spinner className="size-8" />;
};

export const PageCenteredCustomSpinner = () => {
  return (
    // v3 App.scss `.page-centered-custom-spinner` geometry as utilities
    // (App.scss dies at R16); class kept for locator compatibility.
    <div className="page-centered-custom-spinner absolute start-1/2 top-1/2 flex size-25 -translate-x-1/2 -translate-y-1/2 items-center justify-center rtl:translate-x-1/2">
      <CustomSpinner />
    </div>
  );
};

export default PageCenteredCustomSpinner;
